// extracted by mini-css-extract-plugin
module.exports = {"brandInformationPanel":"BrandInformationPanel_brandInformationPanel__1kaTs","data":"BrandInformationPanel_data__89w4m","title":"BrandInformationPanel_title__1AnTE"};